export default __webpack_public_path__ + "static/media/sp-im-boy.b3be92f5.webp";